<template>
  <div id="expired">
    <img :src="imgUrl">
    <p class="p1">登录超时啦</p>
    <p class="p2">请前往大麦系统重新授权登录！</p>
  </div>
</template>

<script>
import { user, infoGet } from '../api/user'
export default {
 data(){
    return{
      imgUrl:require('../assets/img/expired.svg')
    }
  },
  mounted(){
    // let barleyUrl = JSON.parse(sessionStorage.getItem('barleyUrl'))
    let barleyUrl = JSON.parse(this.$cookie.get('barleyUrl'))
    if(barleyUrl){
    this.$message({message:'即将在三秒钟后自动跳转至大麦',type:'warning'})
      setTimeout(function(){
        window.location.href = barleyUrl
      },3000)
    }
    
  }
}
</script>

<style lang="scss">
#expired{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  >img{
    // width: 780px;
    // height: 440px;
  }
  >.p1{
    font-size: 24px;
    margin-top: 56px;
    margin-bottom: 8px;
  }
  >.p2{
    font-size: 14px;
    color: #808080;
  }
}
</style>